var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildcar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M206,358h81v60.7H206Z",
    transform: "translate(-206 -358)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M225,139.21h71.947v36.162H225Z",
    transform: "translate(-225 -139.21)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_5_",
    "data-name": "download (5)",
    transform: "translate(694.29 2541.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M310.134,213.7a20.627,20.627,0,1,1,14.559-6.042,20.6,20.6,0,0,1-14.559,6.042Zm0-37.672a17.091,17.091,0,1,0,12.068,5.006A17.075,17.075,0,0,0,310.134,176.033Z",
    transform: "translate(-63.634 -25.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M429.893,305.9a1.771,1.771,0,0,1-.335-3.525c.221,0,21.93-4.407,21.93-17.108,0-8.03-2.644-8.03-4.266-8.03-1,0-1.6,2.433-2.08,4.407a12.1,12.1,0,0,1-1.825,4.751c-2.23,2.811-6.584,3.931-8.981,4.345a1.763,1.763,0,1,1-.609-3.473c3.244-.564,5.738-1.683,6.848-3.077h0a11.6,11.6,0,0,0,1.155-3.394c.741-2.979,1.763-7.051,5.5-7.051,6.982,0,7.792,6.593,7.792,11.555,0,15.592-23.8,20.37-24.786,20.564a1.717,1.717,0,0,1-.344.035Z",
    transform: "translate(-169.077 -102.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M394.885,459.93h-1.031a6.285,6.285,0,0,1-6.276-6.276,7.05,7.05,0,0,1,2.16-4.715l.247-.282c3.306-3.711,5.121-5.756,5.121-9.326,0-3.993-1.939-6.523-2.759-6.523a1.763,1.763,0,0,1,0-3.526c3.4,0,6.284,4.6,6.284,10.049,0,4.918-2.521,7.748-6.012,11.67l-.247.282a3.889,3.889,0,0,0-1.269,2.371h0a2.76,2.76,0,0,0,2.75,2.751h1.031c4.46,0,13.037-7.845,13.037-18.58,0-4.989-2.785-8.894-5.641-12.464a1.763,1.763,0,0,1,2.75-2.2c3.1,3.879,6.417,8.533,6.417,14.667,0,11.7-9.264,22.106-16.562,22.106Z",
    transform: "translate(-138.32 -215.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M235.588,306.009a1.674,1.674,0,0,1-.334,0c-1.013-.194-24.786-4.98-24.786-20.564,0-4.963.811-11.555,7.792-11.555,3.755,0,4.76,4.081,5.5,7.051a11.566,11.566,0,0,0,1.154,3.394c1.137,1.428,3.826,2.592,7.2,3.129h0a1.785,1.785,0,0,1-.556,3.526c-2.512-.4-7.051-1.508-9.4-4.407a12.558,12.558,0,0,1-1.825-4.751c-.459-1.843-1.084-4.407-2.08-4.407-1.6,0-4.266,0-4.266,8.03,0,12.692,21.71,17.065,21.93,17.108a1.771,1.771,0,1,1-.335,3.526Z",
    transform: "translate(-3.403 -102.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M281.825,462.165h-1.031c-7.3,0-16.562-10.41-16.562-22.107,0-6.17,3.7-10.948,6.487-14h0a1.778,1.778,0,1,1,2.644,2.38c-2.389,2.644-5.562,6.664-5.562,11.618,0,10.735,8.576,18.58,13.037,18.58h1.031a2.76,2.76,0,0,0,2.75-2.751,3.8,3.8,0,0,0-1.269-2.371l-.247-.282c-3.526-3.923-6.012-6.761-6.012-11.67,0-5.289,3.526-10.049,6.284-10.049h0a1.764,1.764,0,0,1,.132,3.526c-.767.353-2.891,3.067-2.891,6.531s1.816,5.614,5.121,9.326l.247.282h0a7.051,7.051,0,0,1,2.159,4.715,6.285,6.285,0,0,1-6.32,6.267Z",
    transform: "translate(-44.359 -218.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M349,405.3H333.922a1.764,1.764,0,0,1-1.763-1.614l-1.5-17.329a1.761,1.761,0,0,1,1.763-1.912H350.5a1.763,1.763,0,0,1,1.764,1.912l-1.517,17.329A1.763,1.763,0,0,1,349,405.3Zm-13.451-3.526h11.829l1.2-13.8H334.336Z",
    transform: "translate(-94.958 -186.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M306.138,332.523H298.6a1.763,1.763,0,0,1-1.463-.785l-10.577-15.866a1.763,1.763,0,0,1,1.084-2.7l6.779-1.463a1.762,1.762,0,0,1,1.859.758L307.645,329.8a1.763,1.763,0,0,1-1.481,2.724ZM299.545,329h3.341l-8.815-13.583-3.077.688Z",
    transform: "translate(-61.144 -131.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M384.169,334.912h-7.536a1.763,1.763,0,0,1-1.508-2.706l10.577-16.58a1.763,1.763,0,0,1,1.666-.811l7.536.749h0a1.763,1.763,0,0,1,1.287,2.732l-10.577,15.866a1.764,1.764,0,0,1-1.446.749Zm-4.328-3.526h3.376l8.409-12.578-3.526-.353Z",
    transform: "translate(-128.625 -133.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M281.8,404.214H264.985a1.762,1.762,0,0,1-1.674-2.318l2.257-6.779h0a1.763,1.763,0,0,1,1.675-1.207h13.8a1.763,1.763,0,1,1,0,3.525H268.511l-1.084,3.252H281.8a1.763,1.763,0,0,1,0,3.526Z",
    transform: "translate(-43.589 -194.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M360.427,468.225h-9.044a1.763,1.763,0,0,1-1.763-1.763v-7.528a1.763,1.763,0,0,1,1.763-1.763h9.044a1.763,1.763,0,0,1,1.764,1.763v7.537a1.764,1.764,0,0,1-1.763,1.754Zm-7.281-3.526h5.518v-4h-5.518Z",
    transform: "translate(-109.405 -242.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M421.076,404.212H405.14a1.763,1.763,0,1,1,0-3.526h13.75l-.723-3.252H405.9a1.763,1.763,0,0,1,0-3.525h13.672a1.762,1.762,0,0,1,1.763,1.384l1.508,6.779h0a1.764,1.764,0,0,1-1.763,2.142Z",
    transform: "translate(-150.355 -194.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M365.4,413.235H360.89a1.763,1.763,0,1,1,0-3.526h4.522a1.763,1.763,0,0,1,0,3.526Z",
    transform: "translate(-116.646 -206.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(206 191.334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M261.564,419.087H232.089c-13.071,0-20.159-8.039-22.247-14.914l-2.257-8.242c-3.235-10.78,1.146-16.219,3.023-18.51h0a13.052,13.052,0,0,0,2.645-9.695c-.211-1.763-.449-4.2-.705-7.246a1.769,1.769,0,0,1,3.526-.3c.256,3.006.493,5.412.7,7.131h0a16.6,16.6,0,0,1-3.438,12.288c-1.763,2.212-5.1,6.32-2.38,15.363l2.274,8.259c.617,2.027,4.5,12.34,18.863,12.34h29.474c14.368,0,18.245-10.348,18.88-12.42l2.23-8.145c2.724-9.079-.591-13.221-2.371-15.4h0a16.6,16.6,0,0,1-3.368-12.34c.2-1.71.441-4.108.7-7.131h0a1.769,1.769,0,1,1,3.525.3c-.264,3.059-.5,5.492-.705,7.236h0a13.048,13.048,0,0,0,2.644,9.7c1.869,2.327,6.258,7.765,3.014,18.59l-2.265,8.153c-2.124,6.946-9.211,14.985-22.282,14.985Z",
    transform: "translate(-206.326 -358.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(210.526 139.21)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M295.581,175.181h-.053a1.762,1.762,0,0,1-1.719-1.807c.238-8.709-2.442-16.192-7.739-21.639-5.721-5.888-14.2-9-24.5-9s-18.774,3.111-24.5,9c-5.289,5.438-7.933,12.921-7.739,21.639a1.763,1.763,0,0,1-3.525.1c-.264-9.7,2.759-18.052,8.735-24.2,6.417-6.584,15.76-10.065,27.033-10.065s20.617,3.526,27.035,10.066c5.976,6.17,9,14.508,8.735,24.2h0a1.764,1.764,0,0,1-1.763,1.71Z",
    transform: "translate(-225.602 -139.21)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildcar);
export default __webpack_public_path__ + "static/media/childcar.945c5d01b92c4c32bf3f9b022f4c8871.svg";
export { ForwardRef as ReactComponent };